/* eslint-disable no-unused-vars */
import { ReactElement, SyntheticEvent, ChangeEvent, useEffect } from 'react'
import { InputGroup, FormControl } from 'react-bootstrap'
import {
  Title,
  SubTitle,
  FormContainer,
  FormWrapper,
  Icon,
  Container,
  LoginButton,
  LoginWrapper,
  RegisterText,
  SignupLink,
  LogoWrapper,
  Logo,
  IconWrapper
} from './subcomponents'
import strings from '../../locale/en'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import {
  handleAuthenticate,
  updateUserName,
  updatePassword,
  updateHasError
} from '../../redux/user/actions'
import useBreakpoint from 'use-breakpoint'
import BREAKPOINTS from '../../const/breakpoint'
import { RootState } from '../../redux/store'
import ROUTES from '../../const/routes'
import { Loader, TostMessage } from '../../components'
import { useHistory } from 'react-router-dom'
import { ROLE } from '../../helpers/determineMenu'
import logo from '../../assets/Logo.png'

const Login = (): ReactElement => {
  const {
    isLoading,
    hasError = false,
    isLoggedIn,
    userInfo
  } = useSelector((state: RootState) => state.user, shallowEqual)

  const {
    login: { title, description, submit, loginFailed },
    register: { noAccount, signUp }
  } = strings
  const dispatch = useDispatch()
  const { breakpoint } = useBreakpoint(BREAKPOINTS)
  const history = useHistory()
  const showSignUp = true // @TODO: Disabled for 1st release. Need to revert

  useEffect(() => {
    if (isLoggedIn) {
      switch (userInfo?.role) {
        case ROLE.STUDENT:
          history.push(ROUTES.LEARN)
          break
        case ROLE.ADMIN:
          history.push(ROUTES.DASHBOARD)
          break
        case ROLE.INSTITUTE_ADMIN:
          history.push(ROUTES.BRANCHADMIN)
          break
        case ROLE.TEACHER_ADMIN:
          history.push(ROUTES.PUBLISH_LIST)
          break
        default:
          history.push(ROUTES.TEACHER)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn])

  return (
    <LoginWrapper>
      <Container>
        <FormWrapper>
          <LogoWrapper>
            <Logo src={logo} alt="logo" />
          </LogoWrapper>
          <Title>{title}</Title>
          <SubTitle>{description}</SubTitle>
          <FormContainer
            onSubmit={(e: SyntheticEvent) => {
              e.preventDefault()
              dispatch(
                handleAuthenticate({
                  loginDevice: breakpoint === 'desktop' ? 'website' : 'mobile'
                })
              )
            }}
          >
            <InputGroup className="mb-3">
              <IconWrapper> <Icon icon={['far', 'user']} /></IconWrapper>
              <FormControl
                id='form-input'
                type="text"
                placeholder="Enter username"
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  dispatch(updateUserName(event?.target?.value))
                }
              />
            </InputGroup>
            <InputGroup className="mb-3">
              <IconWrapper><Icon icon={['fas', 'lock']} /></IconWrapper>
              <FormControl
                type="password"
                id='form-input'
                placeholder="Enter password"
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  dispatch(updatePassword(event?.target?.value))
                }
              />
            </InputGroup>
            {isLoading ? (
              <Loader />
            ) : (
              <LoginButton variant="primary" type="submit" disabled={isLoading}>
                {submit}
              </LoginButton>
            )}
          </FormContainer>
          <TostMessage
            show={hasError}
            onCloseHandler={() => dispatch(updateHasError(false))}
            message={loginFailed}
          ></TostMessage>
        </FormWrapper>
        {/* {showSignUp && (
          <RegisterText>
            {noAccount}
            <SignupLink to={ROUTES.REGISTER}>{signUp}</SignupLink>
          </RegisterText>
        )} */}
      </Container>
    </LoginWrapper>
  )
}

export default Login
